(function processDefinition() {
    'use strict';
    angular.module('Entities')
        .service('processCustomerService', [
            'restUrlBuilder', '$injector', 'config', function processService(restUrlBuilder, $injector, config) {

                var restUrlBuilder = restUrlBuilder('wf');
                var signProcesses = undefined;

                this.getById = function getById(id) {

                    return restUrlBuilder.one('processesCustomer', id).get();
                };

                this.checkout = function checkout(id) {

                    return restUrlBuilder.one('processesCustomer/checkout', id).put();
                };

                this.modifyAndSend = function modifyAndSend(process) {
                    return restUrlBuilder.all('processesCustomer/ModifyAndSend').put(process);
                };

                this.advancedGet = function advancedGet(params) {
                    return restUrlBuilder.all('processesCustomer/find').put(params);
                };

                this.exportToXLS = function (filters, headers, sheetName) {
                    var params = {
                        filters: filters,
                        headers: headers,
                        sheetName: sheetName
                    };

                    return restUrlBuilder.all('exportProcess/exportcustomerxls').put(params);
                };

                this.execute = function execute(id) {

                    return restUrlBuilder.one('processesCustomer/execute', id).put();
                };

                this.manualActionBatch = function manualActionBatch(processes) {
                    return restUrlBuilder.all('processesCustomer/ManualActionBatch').put(processes);
                };

                this.setSignProcesses = function (processes) {
                    signProcesses = processes;
                };

                this.getSignProcesses = function () {
                    if (signProcesses) {
                        return signProcesses;
                    } else {
                        return [];
                    }
                };
            }
        ]);
})();